import React, { useState } from 'react';
import { maskAcct } from './v2Shared';
import { previewManualEngine, applyCreate, V2ApiError, V2Engine } from '../../services/optionsTraderV2Service';

/** "+ Manual Engine": account -> Preview -> Create (created paused; Resume starts it). One per account (SP4 §5, D9). */
const ManualEngineCreate: React.FC<{ token: string; accounts: string[]; engines: V2Engine[]; onCreated: (e: V2Engine) => void; onClose: () => void }> = ({ token, accounts, engines, onCreated, onClose }) => {
  const [account, setAccount] = useState('');
  const [planId, setPlanId] = useState<string | null>(null);
  const [err, setErr] = useState<{ message: string; names?: string[] } | null>(null);
  const has = (a: string) => engines.some(e => e.engineType === 'manual' && e.accountNumber === a && e.state !== 'archived');
  const taken = !!account && has(account); // D10: one manual engine per ACCOUNT, so only the selected account matters
  const preview = async () => {
    setErr(null); setPlanId(null);
    if (taken) { setErr({ message: 'This account already has a manual engine' }); return; }
    try { const p = await previewManualEngine(token, account.trim()); setPlanId(p.planId); }
    catch (e: any) {
      const names = e instanceof V2ApiError && e.code === 'V1_NOT_RETIRED' ? (e.detail?.engines || []).map((x: any) => x.name || x.engineId) : undefined;
      setErr({ message: e?.message || 'Preview failed', names });
    }
  };
  const create = async () => {
    if (!planId) return;
    try { const r = await applyCreate(token, planId, `manual-${account}-${planId}`); onCreated(r.engine); onClose(); }
    catch (e: any) { setErr({ message: e?.message || 'Create failed' }); }
  };
  return (
    <div style={{ background: '#1f2937', border: '1px solid #374151', borderRadius: 10, padding: 20, marginBottom: 16 }}>
      <h3 style={{ color: '#f9fafb', margin: '0 0 8px 0' }}>Add manual engine</h3>
      <p style={{ color: '#9ca3af', fontSize: 13 }}>Watches every position on the account that no auto engine opened. New positions are alerts only until you switch them to managed.</p>
      {taken && <p style={{ color: '#fbbf24', fontSize: 13 }}>This account already has a manual engine</p>}
      <label style={{ color: '#d1d5db', fontSize: 13 }}>Account <select aria-label="Account" value={account} onChange={ev => { setAccount(ev.target.value); setPlanId(null); setErr(null); }}>
        <option value="">Select an account</option>
        {accounts.map(a => <option key={a} value={a}>{maskAcct(a)}</option>)}
      </select></label>
      <div style={{ marginTop: 10, display: 'flex', gap: 8 }}>
        <button onClick={preview} disabled={!account.trim() || taken}>Preview</button>
        <button onClick={create} disabled={!planId}>Create (starts paused)</button>
        <button onClick={onClose}>Cancel</button>
      </div>
      {err && (
        <div style={{ color: '#f87171', marginTop: 8, fontSize: 13 }}>
          {err.message}
          {err.names && err.names.length > 0 && <ul>{err.names.map(n => <li key={n}>{n}</li>)}</ul>}
        </div>
      )}
    </div>
  );
};
export default ManualEngineCreate;
